<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="fill"
      d="M8 0.496826C6.41775 0.496826 4.87103 0.966018 3.55544 1.84507C2.23985 2.72412 1.21447 3.97355 0.608967 5.43536C0.00346628 6.89717 -0.15496 8.5057 0.153721 10.0575C0.462403 11.6094 1.22433 13.0349 2.34315 14.1537C3.46197 15.2725 4.88743 16.0344 6.43928 16.3431C7.99113 16.6518 9.59966 16.4934 11.0615 15.8879C12.5233 15.2824 13.7727 14.257 14.6518 12.9414C15.5308 11.6258 16 10.0791 16 8.49682C15.9978 6.37578 15.1542 4.34225 13.6544 2.84245C12.1546 1.34264 10.121 0.499066 8 0.496826ZM11.0077 10.6345C11.4529 10.0106 11.6923 9.26329 11.6923 8.49682C11.6923 7.73036 11.4529 6.98302 11.0077 6.35913L13.2 4.16759C14.2139 5.38238 14.7693 6.9145 14.7693 8.49682C14.7693 10.0791 14.2139 11.6113 13.2 12.8261L11.0077 10.6345ZM5.53846 8.49682C5.53846 8.00998 5.68283 7.53407 5.95331 7.12927C6.22378 6.72447 6.60822 6.40897 7.05801 6.22266C7.5078 6.03635 8.00273 5.98761 8.48022 6.08258C8.95772 6.17756 9.39632 6.412 9.74057 6.75625C10.0848 7.10051 10.3193 7.53911 10.4142 8.0166C10.5092 8.49409 10.4605 8.98903 10.2742 9.43881C10.0879 9.8886 9.77236 10.273 9.36756 10.5435C8.96276 10.814 8.48685 10.9584 8 10.9584C7.34716 10.9584 6.72106 10.699 6.25943 10.2374C5.7978 9.77577 5.53846 9.14966 5.53846 8.49682ZM12.3292 3.29683L10.1377 5.48913C9.51381 5.0439 8.76647 4.80457 8 4.80457C7.23354 4.80457 6.4862 5.0439 5.86231 5.48913L3.67077 3.29683C4.88555 2.2829 6.41768 1.72752 8 1.72752C9.58232 1.72752 11.1144 2.2829 12.3292 3.29683ZM2.8 4.16759L4.99231 6.35913C4.54707 6.98302 4.30775 7.73036 4.30775 8.49682C4.30775 9.26329 4.54707 10.0106 4.99231 10.6345L2.8 12.8261C1.78608 11.6113 1.2307 10.0791 1.2307 8.49682C1.2307 6.9145 1.78608 5.38238 2.8 4.16759ZM3.67077 13.6968L5.86231 11.5045C6.4862 11.9498 7.23354 12.1891 8 12.1891C8.76647 12.1891 9.51381 11.9498 10.1377 11.5045L12.3292 13.6968C11.1144 14.7107 9.58232 15.2661 8 15.2661C6.41768 15.2661 4.88555 14.7107 3.67077 13.6968Z"
      fill="none"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SupportIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
